import React, { useState } from "react";
import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";
import Container from "react-bootstrap/Container";
import Alert from "react-bootstrap/Alert";
import Breadcrumb from "react-bootstrap/Breadcrumb";
import { Link, useNavigate } from "react-router-dom";
import { Spinner } from "react-bootstrap";
import { addOffer } from "../../Api/Offers";
import LocationForm from "../../Components/Offers/LocationForm";
import "../Styles/Login.scss";
import { PayType } from "../../types";
import { useUserContext } from "../../AppContextProvider";

const AddOffer = () => {
  const { user } = useUserContext();
  const [startDate, setStartDate] = useState('');
  const [endDate, setEndDate] = useState('');
  const [startHour, setStartHour] = useState('');
  const [endHour, setEndHour] = useState('');
  const [description, setDescription] = useState('');
  const [title, setTitle] = useState('');
  const [pay, setPay] = useState('');
  const [payType, setPayType] = useState<PayType>({ payTypeID: 0, name: '' });
  const [locations, setLocations] = useState([{
    remote: false,
    country: '',
    postalCode: '',
    city: '',
    street: '',
    houseNumber: '',
    apartmentNumber: ''
  }]);
  const [loading, setLoading] = useState(false);
  const [successMessage, setSuccessMessage] = useState('');
  const [errorMessage, setErrorMessage] = useState('');
  const navigate = useNavigate();

  const handleLocationChange = (index: number, location: any) => {
    const newLocations = [...locations];
    newLocations[index] = location;
    setLocations(newLocations);
  };

  const addLocation = () => {
    setLocations([...locations, {
      remote: false,
      country: '',
      postalCode: '',
      city: '',
      street: '',
      houseNumber: '',
      apartmentNumber: ''
    }]);
  };

  const removeLocation = (index: number) => {
    const newLocations = [...locations];
    newLocations.splice(index, 1);
    setLocations(newLocations);
  };

  const handleSubmit = async (event: React.FormEvent) => {
    event.preventDefault();
    setLoading(true);
    setSuccessMessage('');
    setErrorMessage('');
    try {
      const combinedStartDate = startDate + 'T' + startHour + ':00';
      var combinedEndDate = '';
      if (endDate !== '') {
        combinedEndDate = endDate + 'T' + endHour + ':00';
      }
      const responseData = await addOffer(user.referenceId, { startDate: combinedStartDate, endDate: combinedEndDate, description, title, pay, payType, locations });
      if (responseData.code === 200) {
        setSuccessMessage('Oferta dodana pomyślnie!');
        setTimeout(() => {
          navigate('/pracodawca/panel');
        }, 2000);
      } else {
        setErrorMessage('Dodawanie oferty nieudane: ' + responseData.message);
      }
    } catch (error) {
      console.log(error);
      setErrorMessage('Wystąpił błąd podczas dodawania oferty: ' + error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Container className="container-relative">
      <Breadcrumb>
        <Breadcrumb.Item linkAs={Link} linkProps={{ to: "/" }}>Strona główna</Breadcrumb.Item>
        <Breadcrumb.Item linkAs={Link} linkProps={{ to: "/pracodawca" }}>Pracodawca</Breadcrumb.Item>
        <Breadcrumb.Item linkAs={Link} linkProps={{ to: "/pracodawca/panel" }}>Panel</Breadcrumb.Item>
        <Breadcrumb.Item active>Dodaj ofertę</Breadcrumb.Item>
      </Breadcrumb>
      {loading && (
        <div className="loading-overlay">
          <Spinner animation="border" role="status">
            <span className="visually-hidden">Loading...</span>
          </Spinner>
        </div>
      )}
      <Container className="add-offer-background">
        <Container className="add-offer-box">
          {successMessage && (
            <Alert variant="success" className="text-center">
              {successMessage}
            </Alert>
          )}
          {errorMessage && (
            <Alert variant="danger" className="text-center">
              {errorMessage}
            </Alert>
          )}
          <Form onSubmit={handleSubmit}>
            <Form.Group controlId="formStartDate" className="form-group">
              <Form.Label>Data rozpoczęcia:</Form.Label>
              <Form.Control
                type="date"
                placeholder="Wprowadź datę rozpoczęcia"
                value={startDate}
                onChange={(e) => setStartDate(e.target.value)}
                required
              />
              <Form.Control
                type="time"
                placeholder="Wprowadź godzinę rozpoczęcia"
                value={startHour}
                onChange={(e) => setStartHour(e.target.value)}
                required
              />
            </Form.Group>

            <Form.Group controlId="formEndDate" className="form-group">
              <Form.Label>Data zakończenia:</Form.Label>
              <Form.Control
                type="date"
                placeholder="Wprowadź datę zakończenia"
                value={endDate}
                onChange={(e) => setEndDate(e.target.value)}
              />
              <Form.Control
                type="time"
                placeholder="Wprowadź godzinę zakończenia"
                value={endHour}
                onChange={(e) => setEndHour(e.target.value)}
              />
            </Form.Group>

            <Form.Group controlId="formTitle" className="form-group">
              <Form.Label>Tytuł:</Form.Label>
              <Form.Control
                type="text"
                placeholder="Wprowadź tytuł"
                value={title}
                onChange={(e) => setTitle(e.target.value)}
                required
              />
            </Form.Group>

            <Form.Group controlId="formDescription" className="form-group">
              <Form.Label>Opis:</Form.Label>
              <Form.Control
                as="textarea"
                rows={3}
                placeholder="Wprowadź opis"
                value={description}
                onChange={(e) => setDescription(e.target.value)}
                required
              />
            </Form.Group>

            <Form.Group controlId="formPay" className="form-group">
              <Form.Label>Wynagrodzenie:</Form.Label>
              <Form.Control
                type="number"
                placeholder="Wprowadź wynagrodzenie"
                value={pay}
                onChange={(e) => setPay(e.target.value)}
                required
              />
            </Form.Group>

            <Form.Group controlId="formPayType" className="form-group">
              <Form.Label>Typ wynagrodzenia:</Form.Label>
              <Form.Control
                as="select"
                value={payType.name}
                onChange={(e) => setPayType({ ...payType, name: e.target.value })}
                required
              >
                <option value="">Wybierz typ wynagrodzenia</option>
                <option value="Godzinowa">Godzinowa</option>
                <option value="Miesięczna">Miesięczna</option>
              </Form.Control>
            </Form.Group>

            {locations.map((location, index) => (
              <LocationForm
                key={index}
                index={index}
                location={location}
                onLocationChange={handleLocationChange}
                onLocationRemove={removeLocation}
              />
            ))}

            <Button variant="secondary" onClick={addLocation} className="button">
              Dodaj lokalizację
            </Button>

            <Button variant="primary" type="submit" className="button" disabled={loading}>
              Dodaj ofertę
            </Button>
          </Form>
        </Container>
      </Container>
    </Container>
  );
};

export default AddOffer;